import axiosInstance from "../configs/axios";
import { route } from "ziggy-js";


export async function submitDemoRequest(formData) {
    return (await axiosInstance.post(route("jsapi.requestCallSubmit"), formData)).data;
}
